(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giveaway-entry-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sac-entry-badge')) return;

    const queue = new Set();
    const cache = new Map();
    const groupsInFlight = new Set();
    let scheduled = false;
    const query = `
      query QuerySweepstakeDetailsByProductId($platform: String!, $platformId: String!, $productIds: [String!]) {
        sweepstakeDetailsByProductId(platform: $platform, platformId: $platformId, productIds: $productIds) {
          id
          entryManagement
          productsAllowedByDefault
          bonusEntriesDefault
          membershipManagement
          membershipProductMultOverride
          scheduledBonusValue
          scheduledBonusActive
          products(productIds: $productIds) {
            productId
            productAllowed
            productBonusEntries
            productMultiplier
          }
        }
      }
    `;

    function entriesForPrice(detail, productId, cents) {
      if (!detail || detail.membershipProductMultOverride || !Number.isFinite(cents) || cents < 0) return null;
      let management;
      try {
        management = JSON.parse(detail.entryManagement);
      } catch {
        return null;
      }
      const product = detail.products.find(item => item.productId === productId);
      const allowed = product ? product.productAllowed : detail.productsAllowedByDefault;
      if (!allowed) return null;
      const dollars = Number(management.dollarSpent);
      const scheduledValue = Number(detail.scheduledBonusValue);
      const rate = detail.scheduledBonusActive && Number.isFinite(scheduledValue) && scheduledValue > 0
        ? scheduledValue : Number(management.entryPer);
      const multiplier = Number(product?.productMultiplier ?? 1);
      const bonus = Number(product ? product.productBonusEntries : detail.bonusEntriesDefault);
      if (!(dollars > 0) || ![rate, multiplier, bonus].every(Number.isFinite)) return null;
      const round = management.roundUp === undefined || management.roundUp ? Math.ceil : Math.floor;
      const entries = round((rate / dollars) * round(cents / 100)) * multiplier + bonus;
      return Number.isFinite(entries) && entries > 0 ? entries : null;
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(flush, 0);
    }

    async function flush() {
      scheduled = false;
      const groups = new Map();
      for (const element of [...queue]) {
        queue.delete(element);
        if (!element.isConnected) continue;
        const key = `${element.dataset.shopId}:${element.dataset.sweepstakeId}`;
        if (groupsInFlight.has(key)) {
          queue.add(element);
          continue;
        }
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(element);
      }
      for (const [key, elements] of groups) {
        groupsInFlight.add(key);
        try {
          const missing = [...new Set(elements.map(element => element.dataset.productId))]
            .filter(id => !cache.has(`${key}:${id}`));
          for (let offset = 0; offset < missing.length; offset += 50) {
            const ids = missing.slice(offset, offset + 50);
            const response = await fetch('https://backend.cleansweeps.app/graphql', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              signal: AbortSignal.timeout(10000),
              body: JSON.stringify({
                query,
                variables: {
                  platform: 'Shopify',
                  platformId: `gid://shopify/Shop/${elements[0].dataset.shopId}`,
                  productIds: ids.map(id => `gid://shopify/Product/${id}`)
                }
              })
            });
            if (!response.ok) throw new Error('Entry settings unavailable');
            const result = await response.json();
            const details = result.data?.sweepstakeDetailsByProductId;
            if (!Array.isArray(details) || result.errors?.length) throw new Error('Entry settings unavailable');
            const detail = details.find(item => String(item.id) === elements[0].dataset.sweepstakeId) ?? null;
            ids.forEach(id => cache.set(`${key}:${id}`, detail));
          }
          elements.forEach(element => element.showEntries(cache.get(`${key}:${element.dataset.productId}`)));
        } catch {
          elements.forEach(element => { element.hidden = true; });
        } finally {
          groupsInFlight.delete(key);
          if (queue.size) schedule();
        }
      }
    }

    class SacEntryBadge extends HTMLElement {
      connectedCallback() {
        queue.add(this);
        schedule();
      }

      disconnectedCallback() {
        queue.delete(this);
      }

      showEntries(detail) {
        const id = `gid://shopify/Product/${this.dataset.productId}`;
        const minimum = entriesForPrice(detail, id, Number(this.dataset.priceMin));
        const maximum = entriesForPrice(detail, id, Number(this.dataset.priceMax));
        if (minimum === null || maximum === null) {
          this.hidden = true;
          return;
        }
        const format = new Intl.NumberFormat(document.documentElement.lang || 'en');
        const count = minimum === maximum ? format.format(minimum) : `${format.format(minimum)}–${format.format(maximum)}`;
        this.querySelector('.sac-entry-badge__count').textContent = this.dataset.label.replace('__COUNT__', count);
        this.title = this.dataset.description;
        this.hidden = false;
      }
    }

    customElements.define('sac-entry-badge', SacEntryBadge);
  })();
  } catch(e) { console.error(e); }
})();

})();
